// extracted by mini-css-extract-plugin
export default {"videoPlay":"VideoPlay_videoPlay__AyZE1","btnText":"VideoPlay_btnText__bDJkX"};